import styled from "styled-components/macro"

export const StyledHelperText = styled('p')`
    text-align: left;
    font-size: 0.8rem;
    margin: 0 0 0 12px;
    color: ${props=> props.type === 'info' ? '#5c9ad0' : props.type === 'error' ? '#e13144' : '#000'}
`;